module.exports = __webpack_public_path__ + "img/BARCODE.1dae42cc.svg";